import { Component, inject, Input, computed, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'mobi-ld-schema',
  imports: [],
  templateUrl: './mobi-ld-schema.component.html',
  styleUrl: './mobi-ld-schema.component.scss',
  host: { ngSkipHydration: 'true' },
  standalone: true,
})
export class MobiLdSchemaComponent {
  readonly schema = input.required();
  #sanitizer = inject(DomSanitizer);

  safeSchemaScript = computed<SafeHtml | null>(() => {
    if (typeof this.schema() === 'string') {
      return this.#sanitizer.bypassSecurityTrustHtml(this.schema() as string);
    } else if (typeof this.schema() == 'object') {
      const json = JSON.stringify(this.schema());
      const tag = `<script type="application/ld+json">${json}</script>`;
      return this.#sanitizer.bypassSecurityTrustHtml(tag);
    }
    return null;
  });
}
